import { useMeetingSelector } from "@kalyzee/kast-web-sdk";
import { useAppStoreSelector } from "../../contexts/appStore/selectors";
import { SurveyStatus } from "@kalyzee/kast-web-sdk/websocket";
import { ReactIcons, RevealContainer } from "@kalyzee/kalyzee-ui";
import { useAppStoreDispatch } from "../../contexts/appStore/context";
import { MainClockElapsedRenderer } from "../renderers/mainClock";
import React from "react";
import { useMeetingContainerContext } from "../../contexts/meetingContainer/context";

export const SurveyBar = React.memo(() => {
  const { containerAPI } = useMeetingContainerContext();

  const [survey] = useMeetingSelector(containerAPI, "surveys", surveys => surveys?.[0]);
  const workBoxMode = useAppStoreSelector(state => state.workBoxMode);
  const workBoxOpen = useAppStoreSelector(state => state.workBoxOpen);
  const dispatch = useAppStoreDispatch();

  const isMobile = useAppStoreSelector(state => state.isMobile);
  const surveyBoxIsOpen = workBoxMode === "survey" && workBoxOpen;
  const hasSurvey = survey && survey.status === SurveyStatus.Open;
  const question = survey?.questions?.[0];

  // On mobile, always show the bar if a survey exists.
  // On desktop, hide it when the survey workbox is open.
  const visible = !!hasSurvey && !!question && (isMobile || !surveyBoxIsOpen);

  return (
    <RevealContainer
      open={visible}
      direction="vertical"
      duration={400}
      easing="cubic-bezier(.4, 0, .2, 1)"
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "1em",
          backgroundColor: "var(--color-element-survey-bar-bg)",
          color: "white",
          padding: "0.5em",
          cursor: "pointer",
        }}
        onClick={() => { dispatch("setWorkBoxMode", "survey"); dispatch("setWorkBoxOpen", true); }}
      >
        <ReactIcons.Stats style={{ height: "1em", width: "1em" }} />
        {question?.content}
        {survey?.createdAt && (
          <MainClockElapsedRenderer
            since={survey.createdAt}
            render={elapsed => (
              <div style={{ opacity: 0.75, display: "flex", gap: "0.25em", fontSize: "1em", alignItems: "center" }}>
                <ReactIcons.Timer style={{ height: "1em" }} />
                {elapsed}
              </div>
            )}
          />
        )}
      </div>
    </RevealContainer>
  );
});
